import { urlPrefixes } from '@/constant/urlPrefixes'
import { ajax, http, ResultType } from '@/utils'
import qs from 'query-string'

const api = {
  queryConfigure: `${urlPrefixes.svsactivityapi}/svshd-web/appclue/queryWishDetail.do`,
  submitConfigure: `${urlPrefixes.svsactivityapi}/svshd-web/appclue/pushWishDetail.do`,
  queryCmsData: `${urlPrefixes.cms999}/travel-configure.json`
}

export async function queryConfigure(setId: string) {
  const result: ResultType<any> = await http.get(
    `${api.queryConfigure}?setId=${setId}`
  )
  const { data, code } = result
  if (code == '1') {
    return data || null
  } else {
    throw result
  }
}

export async function submitConfigure(params: any) {
  const result: ResultType<any> = await http.post(
    `${api.submitConfigure}`,
    qs.stringify(params),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }
  )
  const { data, code } = result
  if (code == '1') {
    return data || null
  } else {
    throw result
  }
}

export async function queryCmsData() {
  const result: ResultType<any> = await ajax.get(`${api.queryCmsData}`)
  const { data, code } = result
  if (code == 0) {
    return data || null
  } else {
    throw result
  }
}
